import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderFileRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("workorderfile");
